'use client';

import type { GfProductColor } from '@/types';
import type { StaticImageData } from 'next/image';
import GfColorSwatches from '../GfColorSwatches/GfColorSwatches';
import OptionTitle from '../OptionTitle/OptionTitle';
import styles from './GfColorList.module.scss';

function GfColorList({
  colors,
  onColorSelect,
  // biome-ignore lint/correctness/noUnusedVariables: カラーごとの価格差がなくなるため一旦コメントアウト
  productBasePrice,
  selectedColorId,
  showColorName = true,
  iconSize = 'default',
  title = '色を選択',
  titleImage,
}: {
  colors: GfProductColor[];
  onColorSelect?: (colorId: number) => void;
  productBasePrice?: number;
  selectedColorId: number;
  showColorName?: boolean;
  iconSize?: 'small' | 'default';
  title?: string;
  // 見出しを画像化したい場合に渡す（OptionTitle の image に委譲）。未指定なら title テキスト表示
  titleImage?: StaticImageData;
}) {
  return (
    <div className={styles.productColorOptionContainer}>
      <OptionTitle title={title} image={titleImage} />
      {selectedColorId === 0 && <p className={styles.productColorValidationErrorMessage}>カラーが未選択です</p>}
      <GfColorSwatches
        colors={colors}
        onColorSelect={onColorSelect}
        selectedColorId={selectedColorId}
        showColorName={showColorName}
        iconSize={iconSize}
      />
    </div>
  );
}

export default GfColorList;
